'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HS_logo_white = require('landing-pages/assets/HS_logo_white.svg');

var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);

var _googledocs_logo = require('landing-pages/assets/googledocs_logo.svg');

var _googledocs_logo2 = _interopRequireDefault(_googledocs_logo);

var _clouds_googledocs = require('landing-pages/assets/clouds_googledocs.svg');

var _clouds_googledocs2 = _interopRequireDefault(_clouds_googledocs);

var _overlay_left = require('landing-pages/assets/overlay_left.svg');

var _overlay_left2 = _interopRequireDefault(_overlay_left);

var _overlay_right = require('landing-pages/assets/overlay_right.svg');

var _overlay_right2 = _interopRequireDefault(_overlay_right);

var _approval_icon = require('landing-pages/assets/approval_icon.svg');

var _approval_icon2 = _interopRequireDefault(_approval_icon);

var _drop_signature_icon = require('landing-pages/assets/drop_signature_icon.svg');

var _drop_signature_icon2 = _interopRequireDefault(_drop_signature_icon);

var _security_icon = require('landing-pages/assets/security_icon.svg');

var _security_icon2 = _interopRequireDefault(_security_icon);

var _screenshot_googledocs = require('landing-pages/assets/screenshot_googledocs.png');

var _screenshot_googledocs2 = _interopRequireDefault(_screenshot_googledocs);

var _socialSection = require('landing-pages/components/common/social-section');

var _socialSection2 = _interopRequireDefault(_socialSection);

var _faqSection = require('landing-pages/components/common/faq-section');

var _faqSection2 = _interopRequireDefault(_faqSection);

var _benefitsSection = require('landing-pages/components/common/benefits-section');

var _benefitsSection2 = _interopRequireDefault(_benefitsSection);

var _pricingCtaSection = require('landing-pages/components/common/pricing-cta-section');

var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);

var _ctaButton = require('landing-pages/components/common/cta-button');

var _ctaButton2 = _interopRequireDefault(_ctaButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function GoogleDocs(p) {
    // Google Docs constants
    var benefits = [{
        icon: _approval_icon2['default'],
        title: 'Simplify signing',
        text: 'Remove extra steps from the document lifecycle by writing, editing, sending a document for signature, and signing it in Google Docs.'
    }, {
        icon: _drop_signature_icon2['default'],
        title: 'Click and insert your signature',
        text: 'Before you send or download your document, just click to insert your signature wherever it needs to be.'
    }, {
        icon: _security_icon2['default'],
        title: 'HelloSign docs are safe and secure',
        text: 'All signed documents are legally binding and automatically backed up in your HelloSign account.'
    }];
    var howItWorks = ['Connect your Google Drive and HelloSign accounts to start signing documents from within Google Drive. Then you’ll be able to sign or send any document in your drive folders.', 'On HelloSign.com, you’ll also be able to import documents stored in Google Drive.', 'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'];
    var twitterLink = 'https://twitter.com/intent/tweet?original_referer=https%3a%2f%2fwww.hellosign.com%2fgoogle-docs-add-on&ref_src=twsrc%5Etfw&text=Did%20you%20know%20%40HelloSign%20integrates%20with%20%40GoogleDocs%3F%20Sign%20documents%20directly%20from%20Google%20Docs.&tw_p=tweetbutton&url=https%3a%2f%2fwww.hellosign.com%2fgoogle-docs-add-on%3futm_medium%3Ds2s%26utm_source%3Dtwitter';
    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/google-docs-add-on?utm_source=facebook%26utm_medium=s2s';
    var linkedInLink = 'https://www.linkedin.com/cws/share?url=https%3a%2f%2fwww.hellosign.com%2fgoogle-docs-add-on%3futm_medium%3Ds2s%26utm_source%3Dlinkedin&original_referer=https%3a%2f%2fwww.hellosign.com%2fgoogle-docs-add-on&token=&isFramed=false&lang=en_US&_ts=1462214138386.6147&xd_origin_host=https%3A%2F%2Fwww.hellosign.com';
    var border = '2px solid #D7D7D7';

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations' },
        _react2['default'].createElement(IllustrationArea, p),
        _react2['default'].createElement(
            'div',
            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top', style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
            _react2['default'].createElement(HowItWorks, {
                image: _screenshot_googledocs2['default'],
                explanation: howItWorks }),
            _react2['default'].createElement(_socialSection2['default'], {
                title: 'Share with your networks!',
                twitterLink: twitterLink,
                facebookLink: facebookLink,
                linkedInLink: linkedInLink }),
            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/articles/205794398-HelloSign-For-Google-Docs-Add-on' }),
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom', style: { borderTop: border, fontWeight: 600 } })
        )
    );
}

function HowItWorks(p) {
    var linkURL = 'https://www.hellosign.com/info/googleDocsInstall';
    var link = _react2['default'].createElement(
        'a',
        { href: linkURL, target: '_blank', rel: 'noopener noreferrer' },
        'Add the free HelloSign add-on'
    );

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__how-it-works' },
        _react2['default'].createElement(
            'h2',
            null,
            'How it Works'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement(
                'div',
                { className: 'screenshot-explanation large-3 large-push-9 columns' },
                _react2['default'].createElement(
                    'p',
                    null,
                    link,
                    ' for Google Docs to start signing directly inside Google Docs. From the HelloSign sidebar, you\u2019ll be able to sign documents or send them for signature.'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'To sign a document, draw a new signature or insert any previously saved signatures. Then email it as a legally binding PDF.'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'If someone else needs to sign your Google Doc, this extension automatically imports your document into HelloSign to add recipients and signature fields.'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'dropbox-screenshot large-9 large-pull-3 columns' },
                _react2['default'].createElement('img', { src: _screenshot_googledocs2['default'], alt: 'google drive screenshot' })
            )
        )
    );
}

function IllustrationArea(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'top row', style: { backgroundColor: '#B1DCF5' } },
        _react2['default'].createElement(
            'div',
            { className: 'top-content-container large-5 large-push-6 columns' },
            _react2['default'].createElement(
                'div',
                { className: 'hellosign-dropbox' },
                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
                _react2['default'].createElement(
                    'span',
                    { className: 'plus' },
                    '+'
                ),
                _react2['default'].createElement('img', { src: _googledocs_logo2['default'], alt: 'GoogleDocs Logo', className: 'dropbox-logo' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'title' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Sign and send Google Docs in seconds'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'subtitle' },
                _react2['default'].createElement(
                    'h2',
                    null,
                    'Add your signature to a Google Doc or add fields for others to fill out and sign. Now you can write, invite others to comment and redline, and send a document for signature entirely from within Google Docs \u2014 there\u2019s no need to export and upload.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'signup-button' },
                _react2['default'].createElement(_ctaButton2['default'], _extends({}, p, {
                    buttonText: 'Try it free' }))
            )
        ),
        _react2['default'].createElement(
            'div',
            { className: 'clouds-container large-5 large-pull-4 columns' },
            _react2['default'].createElement('img', { src: _clouds_googledocs2['default'], alt: 'cloud left' })
        ),
        _react2['default'].createElement('img', { src: _overlay_left2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud left', className: 'cloud-left' }),
        _react2['default'].createElement('img', { src: _overlay_right2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud right', className: 'cloud-right' })
    );
}

module.exports = GoogleDocs;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/google-docs.jsx
 ** module id = 1654
 ** module chunks = 0
 **/